import { useInstantSearch } from 'react-instantsearch'

import { createInsightsMiddleware } from 'instantsearch.js/es/middlewares'
import { useLayoutEffect } from 'react'
import aa from 'search-insights'

export default function Insights() {
  const { addMiddlewares } = useInstantSearch()

  // The Insights middleware is added in a layout effect because it mounts
  // a <Configure> widget. Widgets must be added in layout effects to minimize
  // the number of network requests.
  useLayoutEffect(() => {
    const middleware = createInsightsMiddleware({
      insightsClient: aa,
      insightsInitParams: {
        useCookie: true,
      },
      onEvent: (event) => {
        // Send the event to Algolia
        // if (event.insightsMethod) {
        //   aa(event.insightsMethod, event.payload)
        // }
        aa(event.insightsMethod, event.payload)

        // Send the event to a third-party tracker
        if ('dataLayer' in window) {
          // eslint-disable-next-line @typescript-eslint/ban-ts-comment
          // @ts-ignore
          if (event.widgetType === 'ais.infiniteHits') window.dataLayer.push({ event: event.payload.eventName })
        }
      },
    })

    return addMiddlewares(middleware)
  }, [addMiddlewares])

  return null
}
